import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { selectProposalDashboardFilters } from "slices/proposalDashboard";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/proposal-dashboard/widgets/notifications";

export const fetchProposalNotifications = createAsyncThunk(
  "proposalNotificationsWidget/fetch",
  async (_, { getState }) => {
    const filters = selectProposalDashboardFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);
    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);
